import initialState from '../store/initialState'
import scriptsTypes from '../constants/scriptsTypes'

const { toast } = window.M

export default function scriptsReducer(state = initialState.scripts, action) {
  //console.log(action.type)
  switch (action.type) {

    case scriptsTypes.reset_errors: {
      return {
        ...state,
        errors: []
      }
    }

    // INDEX
    case scriptsTypes.index.request: {
      return {
        ...state,
        errors: [],
        fetching: true,
        fetched: false
      }
    }

    case scriptsTypes.index.success: {
      return {
        ...state,
        errors: [],
        fetching: false,
        fetched: true,
        items: action.payload.scripts,
      }
    }

    case scriptsTypes.index.failure: {
      toast({
        html: action.payload
      })
      return {
        ...state,
        errors: action.payload,
        fetching: false,
        fetched: false
      }
    }

    // UPDATE
    case scriptsTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case scriptsTypes.update.success: {
      toast({
        html: "Rule updated successfully"
      })
      const {script}=action.payload
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        items: state.items.map( item => {
          if (item.id === script.id) {
            return script
          } else {
            return item
          }
        })
      }
    }

    case scriptsTypes.update.failure: {
      if (action.payload && action.payload.length > 0) {
        toast({
          html: action.payload.join("\n")
        })
      }
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // DELETE
    case scriptsTypes.destroy.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case scriptsTypes.destroy.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        items: action.payload.scripts,
      }
    }

    case scriptsTypes.destroy.failure: {
      if (action.payload && action.payload.length > 0) {
        toast({
          html: action.payload.join("\n")
        })
      }
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // CREATE
    case scriptsTypes.create.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case scriptsTypes.create.success: {
      toast({
        html: "Rule created successfully"
      })
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.scripts,
        errors: []
      }
    }

    case scriptsTypes.create.failure: {
      if (action.payload && action.payload.length > 0) {
        toast({
          html: action.payload.join("\n")
        })
      }
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/scriptsReducer.js